import { createAction } from '@mews/framework/redux';
import {
    FETCH_PAYMENT_CARDS_FAILED,
    FETCH_PAYMENT_CARDS_STARTED,
    FETCH_PAYMENT_CARDS_SUCCEEDED,
} from '../../modules/entities/paymentCards/actionTypes';
import { ApplicationState } from '../../types';

export const fetchPaymentCards =
    ({ paymentCardIds }: { paymentCardIds: string[] }) =>
    (dispatch: $TSFixMe, _getState: () => ApplicationState, { apiService }: $TSFixMe) => {
        dispatch(createAction(FETCH_PAYMENT_CARDS_STARTED, { paymentCardIds }));

        return apiService
            .getPaymentCards({ paymentCardIds })
            .then((response: $TSFixMe) => {
                dispatch(createAction(FETCH_PAYMENT_CARDS_SUCCEEDED, response));
                return response;
            })
            .catch((error: $TSFixMe) => {
                dispatch(createAction(FETCH_PAYMENT_CARDS_FAILED, { error }));
                throw error;
            });
    };
